import ProgressRing from './ProgressRing';
import { FONT_TITRE } from '../../utils/qcmTheme';

/** Bandeau haut : contexte de la session à gauche, anneau + compteur à droite. */
const ProjectionHeader = ({ titre, questionOrdre, totalQuestions, nbReponses, totalEleves, action = null }) => (
  <div className="flex items-center justify-between px-9 pt-5 flex-shrink-0">
    <span
      className="font-bold text-xs uppercase truncate text-white/60"
      style={{ letterSpacing: '.16em', fontFamily: FONT_TITRE }}
    >
      TanoEd Live{titre ? ` · ${titre}` : ''} · Question {questionOrdre}{totalQuestions > 0 ? `/${totalQuestions}` : ''}
    </span>
    <span className="flex items-center gap-2.5 flex-shrink-0">
      {action}
      <ProgressRing ratio={totalEleves > 0 ? nbReponses / totalEleves : 0} />
      {/* key={nbReponses} : remontage à chaque réponse reçue → pop ponctuel */}
      <span key={nbReponses} className="proj-count-pop font-black text-xl tabular-nums text-white" style={{ fontFamily: FONT_TITRE }}>
        {nbReponses}{totalEleves > 0 ? `/${totalEleves}` : ''}
      </span>
    </span>
  </div>
);

export default ProjectionHeader;
